import { DataSource } from "@coeff/api";
import React, { ReactNode } from "react";

import { AuthorizeTableauContent } from "../../auth/connectors/tableau/AuthorizeTableauContent";
import { useAuthContext } from "../../auth/context/AuthContext";

type Props = {
  dataSourceType?: string;
  customDescription?: ReactNode;
  isPPressComponent?: boolean;
};

/**
 * PPress-namespace wrapper for AuthorizeTableau.
 *
 * The backend auth form JSX renders `<PPress.AuthorizeTableau dataSourceType="tableau" />`
 * with no callbacks, so this wrapper pulls everything else (post-creation hook, upsert
 * navigation, event props, cancel) from the shared AuthContext that the host provides.
 */
export const AuthorizeTableau: React.FC<Props> = ({ customDescription, isPPressComponent }) => {
  const { eventProps, navigateOnDataSourceUpsert, initPostDataSourceCreation, router } =
    useAuthContext();

  return (
    <AuthorizeTableauContent
      isPPressComponent={isPPressComponent ?? true}
      customDescription={customDescription}
      event_props={{
        email: eventProps?.email,
        domain: eventProps?.domain,
        user_id: eventProps?.user_id,
      }}
      initPostDataSourceCreation={
        initPostDataSourceCreation ?? (({ dataSource, onComplete }) => onComplete(dataSource))
      }
      onDataSourceUpserted={(dataSource: DataSource) => navigateOnDataSourceUpsert?.(dataSource)}
      onCancel={() => router?.back?.()}
    />
  );
};
